import navigation from'../../../pip/library/pi-navigation/pi-navigation.js';
import { View } from'../../../pip/library/pi-interop/pi-interop.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

interface IViewWC extends HTMLElement {
  parameters: Object;
}

/**
 * a view for rendering a single web component as the main view
 */
export class ViewWC extends View {
  private __tagName: string;
  readonly lens = {
    navigationParameters: f1.lens('/location/active/parameters')
  };

  constructor(tagName: string) {
    super();
    this.__tagName = tagName;
  }

  mount(region: HTMLElement): Promise<this> {
    const viewEl = document.createElement(this.__tagName) as IViewWC;

    viewEl.parameters = f1.read(this.lens.navigationParameters, {}, navigation);
    region.append(viewEl);
    return f1.done(this);
  }

  stateChange() {
    const viewEl: IViewWC = this.region.childNodes[0] as IViewWC;

    viewEl.parameters = f1.read(this.lens.navigationParameters, {}, navigation);
    return f1.done(this);
  }
}
